
import { defineComponent } from 'vue'
import PredictionBatch from '@/components/PredictionBatch.vue'

export default defineComponent({
  name: 'Home',
  components: {
    PredictionBatch,
  },
})
